import { Component, Input, OnInit, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { DropDownFormSectionData } from '../dropdown-form-section/dropdown-form-section-data';
import { ProductOrderFormSectionData } from '../order-form/interface';

@Component({
  selector: 'store-order-form-section',
  templateUrl: 'order-form-section.component.html',
  styleUrls: ['./order-form-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderFormSectionComponent implements OnInit {
  @Input() data: ProductOrderFormSectionData;
  @Input() extraHeaderContent: TemplateRef<any>;
  @Input() bottomActionsContent: TemplateRef<any>;

  ngOnInit(): void {
    // The first section should always be expanded.
    const topSection = this.getTopSection();
    if (topSection) {
      topSection.startOpen = true;
    }
  }

  getTopSection(): DropDownFormSectionData {
    if (!this.data) {
      return null;
    }
    if (this.data.primarySection) {
      return this.data.primarySection;
    }
    if (this.data.subsections && this.data.subsections.length > 0) {
      return this.data.subsections[0];
    }
    return null;
  }
}
